import { render, staticRenderFns } from "./HeaderHomeEight.vue?vue&type=template&id=8889232a&"
import script from "./HeaderHomeEight.vue?vue&type=script&lang=js&"
export * from "./HeaderHomeEight.vue?vue&type=script&lang=js&"
import style0 from "./HeaderHomeEight.vue?vue&type=style&index=0&id=8889232a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports